export const formDate = (value) => {
  const dateIso = new Date(value || new Date()).toISOString();
  return new Date(dateIso?.slice(0, -1)).toLocaleDateString("pt-BR");
};
